import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChildFn, Router } from '@angular/router';
import { RestaurantService } from '../services/restaurant.service';
import {
  isLimitedAccessStatus,
  isRouteAllowedForStatus,
  PUBLISHED_STATUS_DEFAULT_ROUTE,
} from '../utils/restaurant-status.util';

/**
 * Keeps a restaurant whose status is `created` or `published` (not yet `activated`)
 * inside the pages that status can use — profile/menu setup and account
 * settings; `created` also loses Billing & Subscription. Everything else
 * under `/main` sends them back to the dashboard.
 * A fully `activated` restaurant is unaffected.
 */
export const RestaurantStatusGuard: CanActivateChildFn = (route: ActivatedRouteSnapshot) => {
  const router = inject(Router);
  const restaurantService = inject(RestaurantService);

  const status = restaurantService.currentRestaurantDetails$.value?.status;
  if (!isLimitedAccessStatus(status)) {
    return true;
  }

  const path = route.routeConfig?.path || '';
  if (isRouteAllowedForStatus(path, status)) {
    return true;
  }

  return router.createUrlTree(['main', PUBLISHED_STATUS_DEFAULT_ROUTE]);
};
